import request from '@/utils/request'

// 查询列表
export function apiBomProductionScheduleAttributeCcList(query) {
  return request({
    url: '/bom/bomProductionScheduleAttributeCc/list',
    method: 'get',
    params: query
  })
}

// 车间编码 我也不想重复定义，但宇平说自己定义会安全点
export function apiBomWorkshopFindList (query) {
  return request({
    url: '/bom/bomWorkshop/findList',
    method: 'get',
    params: query
  })
}

// 修改
export function apiBomProductionScheduleAttributeCcUpdate (data) {
  return request({
    url: '/bom/bomProductionScheduleAttributeCc',
    method: 'put',
    data: data
  })
}

// 导出列表
export function apiBomProductionScheduleAttributeCcExport (data) {
  return request({
    url: '/bom/bomProductionScheduleAttributeCc/export',
    method: 'post',
    data: data
  })
}

// 删除
export function apiBomProductionScheduleAttributeCcDel (id) {
  return request({
    url: '/bom/bomProductionScheduleAttributeCc/' + id,
    method: 'delete'
  })
}

// 新增
export function apiBomProductionScheduleAttributeCcAdd (data) {
  return request({
    url: '/bom/bomProductionScheduleAttributeCc',
    method: 'post',
    data: data
  })
}
